<template>
  <div class="alert alert-soft-success fade show" role="alert">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "DashboardSuccess",
  props: {
    message: String
  }
}
</script>

<style scoped></style>
